import React, { useState } from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useRouteMatch, Switch, Route } from 'react-router-dom'
import {
  getUserModuleActions,
  getUserSubModuleActions,
} from '../../../../store/user/selectors'
import { checkPermission } from '../../../../utils/utilFunctions'
import RlpApplication from './RlpApplication'
import RlpFileView from './RlpFileView'
import RlpReturn from './RlpReturn'

const Rlp = () => {
  const { path } = useRouteMatch()

  const [selectedSection, setSelectedSection] = useState('rlp')

  const actionListModule = useSelector(
    getUserModuleActions('compensation-certification', 'compensation', 'rlp')
  )

  const actionListSubModule = useSelector(
    getUserSubModuleActions(
      'compensation-certification',
      'compensation',
      'rlp',
      'file-return'
    )
  )
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="rlp">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              {checkPermission('view', actionListModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('rlp')
                    }}
                    eventKey="rlp"
                  >
                    RLP Application
                  </Nav.Link>
                </Nav.Item>
              )}
              {checkPermission('view', actionListSubModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('rlp-return')
                    }}
                    eventKey="rlp-return"
                  >
                    RLP Return
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </Row>
          <Row className="page-tiles-layout align-content-start">
            {selectedSection === 'rlp' ? (
              <>
                {checkPermission('view', actionListModule) && (
                  <RlpApplication />
                )}
              </>
            ) : (
              <>
                {checkPermission('view', actionListSubModule) && <RlpReturn />}
              </>
            )}
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/view/:id`}
        render={(props) => <RlpFileView type="view" {...props} />}
      />
      <Route
        path={`${path}/return/:id`}
        render={(props) => <RlpFileView type="file-return" {...props} />}
      />
    </Switch>
  )
}

export default Rlp
